import {QueryState} from '../../../../../_dashboard/helpers'

export type ToursListFilters = {
  search?: string
  status?: '' | 'draft' | 'published'
  category?: string
  city?: string
  types?: string
}

const SORT_FIELD_MAP: Record<string, string> = {
  name: 'title',
  duration: 'duration',
  capacity: 'tourMinPeople',
  status: 'status',
  createdAt: 'createdAt',
}

export function buildToursListQuery(state: QueryState): Record<string, string | number> {
  const search = typeof state.search === 'string' ? state.search.trim() : ''

  const params: Record<string, string | number> = {
    page: state.page ?? 0,
    limit: state.size ?? 10,
    size: state.size ?? 10,
  }

  if (state.language) {
    params.language = state.language
  }

  if (search) {
    params.search = search
    params.q = search
  }

  const status = state.status as ToursListFilters['status'] | undefined
  if (status === 'draft' || status === 'published') {
    params.status = status
  }

  if (state.category) {
    params.category = state.category
  }

  if (state.city) {
    params.city = state.city
  }

  if (state.types) {
    params.types = state.types
  }

  if (state.sort && SORT_FIELD_MAP[state.sort]) {
    params.sortBy = SORT_FIELD_MAP[state.sort]
    params.sortDirection = state.order === 'desc' ? 'desc' : 'asc'
  }

  return params
}
